import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import SiteFooter from "./SiteFooter";
import MobileTabBar from "./MobileTabBar";

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <MobileTabBar />
    </div>
  );
}